/**
 * ProductManager Component
 *
 * This component serves as the main page for product management.
 * It displays product-related informations and functionalities.
 * Such as adding, editing, and deleting products, sims cards, bases, managing product types, and viewing product details.
 *
 * It is only accessible to superadmin users.
 *
 *
 **/

import React, { useContext } from "react";
import UserContext from "../../context/UserContext";
import useTranslation from "../../hooks/useTranslation";
import "./ProductManagerPage.scss";
import PageHeader from "../Shared/PageHeader/PageHeader";
import ProductsSection from "./Products/ProductsSection";
import SimCardsSection from "./SimCards/SimCardsSection";
import BasesSection from "./Bases/BasesSection";
import USER_ROLES from "../../constants/userRoles";
import ProblematicDevicesSection from "./ProblematicDevices/ProblematicDevicesSection";

const ProductManagerPage = () => {
  const { user } = useContext(UserContext);
  const { t } = useTranslation("productManagerPage");

  if (!user || user.roles !== USER_ROLES.SUPER_ADMIN) {
    return (
      <div className="unauthorized-message">
        {t("unauthorized_access_message")}
      </div>
    );
  }

  return (
    <div className="container productmanager-page__container navbar-margin">
      <PageHeader
        title={t("productManager")}
        helperTitle={t("productManager")}
        helperBody={t("productmanager_helper")}
      />
      {/* Products Section */}
      <ProductsSection />
      {/* SIM Cards Section */}
      <SimCardsSection />
      {/* Bases Section */}
      <BasesSection />
      {/* Problematic Devices Section */}
      <ProblematicDevicesSection />
    </div>
  );
};

export default ProductManagerPage;
